import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(talents)/[lang]/talents/main.tsx");
